/**
 * Returns true when two arrays are element-wise identical (===).
 * Does not recurse into nested structures — use deepEqual for that.
 */
export function shallowArrayEqual(a: any[], b: any[]): boolean {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}
